import { ApiClient } from "../../ApiClient"
import { GetProductsListResponse } from "../schema/GetProductsListResponse"
import { ProductsList } from "@/@types"
import { mapProducts } from '@/services/api/mappers/productsListMapper';

export const getProductsList = async (
    industrySlug?: string, 
    familySlug?: string, 
    subfamilySlug?: string, 
    brandSlug?: string, 
    p0?: { page: string }
): Promise<ProductsList> => {
  const client = ApiClient.getInstance()

  const params = new URLSearchParams()

  if (industrySlug) params.append('industry', industrySlug);
  if (familySlug) params.append('family', familySlug);
  if (subfamilySlug) params.append('subfamily', subfamilySlug);
  if (brandSlug) params.append('brand', brandSlug);
  if (p0?.page) params.append('page', p0.page);

  const response = await client.get<GetProductsListResponse>(`products/get-products?${params.toString()}`)

  return { 
    products: response.data.products.map(mapProducts), 
    meta: response.data.meta, 
    links: response.data.links, 
  };
}